// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/routes/login.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/routes/login.tsx");
  import.meta.hot.lastModified = "1745271877021.109";
}
// REMIX HMR END

import React, { useState } from "react";
import { Form, useActionData } from "@remix-run/react";
import { Box, Button, Container, TextField, Typography, Alert } from "@mui/material";
import { loginUser } from "~/utils/auth"; // Adjust the import based on your project structure

// Type for the form data

export const action = async ({
  request
}) => {
  const data = await request.formData();
  const username = data.get("username");
  const password = data.get("password");
  return loginUser(username, password);
};
export default function Login() {
  _s();
  const actionData = useActionData();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  return <Container maxWidth="xs">
      <Box display="flex" flexDirection="column" alignItems="center" sx={{
      mt: 20
    }}>
        <Typography component="h1" variant="h5">
          Login
        </Typography>
        <Box sx={{
        border: "1px solid #ccc",
        borderRadius: "8px",
        padding: "16px",
        mt: 2,
        width: "100%"
      }}>
          <Form method="post">
            <TextField variant="outlined" margin="normal" size="small" required fullWidth id="username" label="Username" name="username" autoComplete="username" autoFocus value={username} onChange={e => setUsername(e.target.value)} />
            <TextField variant="outlined" margin="normal" size="small" required fullWidth name="password" label="Password" type="password" id="password" autoComplete="current-password" value={password} onChange={e => setPassword(e.target.value)} />
            {actionData?.error && <Alert severity="error">{actionData.error}</Alert>}
            <Button type="submit" fullWidth variant="contained" color="primary" sx={{
            mt: 3,
            mb: 2
          }}>
              Login
            </Button>
          </Form>
        </Box>
      </Box>
    </Container>;
}
_s(Login, "MICnmMz6wmQFumyKZiGAc4r5wWg=", false, function () {
  return [useActionData];
});
_c = Login;
var _c;
$RefreshReg$(_c, "Login");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;